import React from 'react';
import c from 'classnames';
import { I18nextProvider } from 'react-i18next';

import i18next from '../../config/i18next';
import SearchMinimal from '../SearchMinimal';
import SearchFull from '../SearchFull';
import SearchOcularDBFull from '../SearchOcularDBFull';

import { APP_OPTIONS } from '../../config/constants';

import './style.scss';

const App = () => {
  const classNames = c('App');

  return (
    <I18nextProvider i18n={i18next}>
      <div className={classNames}>
        <main className="main">

          {/* There is much overlap in these implementations.

          Some parts are components, other parts are duplicates of eachother,
          with small changes, but still share the same style sheets.
          This hopefully forces you to be mindful of changes and their effects in other places.

          Prevention of code duplication would only create much more abstraction and proved not
          beneficial to code readabily. */}

          {(APP_OPTIONS.parameters.showFullSearch && !APP_OPTIONS.parameters.ocularDB) && (
            <SearchFull />
          )}
          {(APP_OPTIONS.parameters.showFullSearch && APP_OPTIONS.parameters.ocularDB) && (
            <SearchOcularDBFull />
          )}
          {(!APP_OPTIONS.parameters.showFullSearch && !APP_OPTIONS.parameters.ocularDB) && (
            <SearchMinimal />
          )}
        </main>
      </div>
    </I18nextProvider>
  );
};

export default App;
